export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-anchor-dbcb507392f6a11f1f72772e85428df9.svg";